import React from 'react';
import { ChakraV3 } from '..';

export const Spin = (
  props: ChakraV3.SpinnerProps & {
    showAfterDuration?: number;
  },
) => {
  const [showSpinner, setShowSpinner] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => setShowSpinner(true), props.showAfterDuration || 0);
    return () => clearTimeout(timer);
  }, [props.showAfterDuration]);

  return (
    <ChakraV3.Center h='full' w='full'>
      {showSpinner && <ChakraV3.Spinner color='purple.500' size='md' {...props} />}
    </ChakraV3.Center>
  );
};
